// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Dts6T","modalFooterButton":"ModalNotes_modalFooterButton__1GGzB"};